var _Services, _Icon;

import React from 'react';
import { Icon, PopoverUi } from "../../../../../Common";
import Services from '../../../Services';
import styles from './ServiceWrapper.scss';

var ServicesWrapper = function ServicesWrapper() {
  return /*#__PURE__*/React.createElement(PopoverUi, {
    content: _Services || (_Services = /*#__PURE__*/React.createElement(Services, null)),
    placement: "bottomRight",
    overlayStyle: {
      position: 'fixed'
    },
    color: "text-inverted"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.iconWrapper
  }, _Icon || (_Icon = /*#__PURE__*/React.createElement(Icon, {
    name: "services"
  }))));
};

export default ServicesWrapper;